import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
const TOMOS = [{
  number: 1,
  title: 'El Despertar del Truquero',
  subtitle: 'De no saber nada a sentarte en cualquier mesa sin vergüenza',
  desc: 'El punto de partida real. Antes de ganar, entender. Antes de mentir, dominar las bases.',
  bullets: ['La baraja española de 40 cartas explicada desde cero', 'El ranking completo de las cartas de mayor a menor (con las 3 confusiones que arruinan a todo principiante)', 'Cómo se reparte, quién es el Mano, quién es el Pie y por qué importa', 'El Envido explicado paso a paso: cómo se calculan los puntos en segundos', 'El Truco: la escala de apuestas y cómo se gana una mano', 'Los 10 errores del novato y cómo evitarlos desde la primera partida', 'Simulaciones reales para practicar antes de sentarte a jugar']
}, {
  number: 2,
  title: 'La Matemática del Envido',
  subtitle: 'El cálculo frío que separa al novato del estratega',
  desc: 'El Envido puede representar hasta el 40% de los puntos de una partida. El que lo ignora, regala.',
  bullets: ['La tabla completa de puntos de Envido para calcular en menos de 5 segundos', 'El semáforo del Envido: zona Roja, Naranja, Amarilla y Azul', 'Cuándo cantar, cuándo no cantar y cuándo mentir según tu posición en la mesa', 'El árbol de decisiones del Envido para cada situación posible', 'Cómo el marcador cambia completamente cada decisión de Envido', 'Los 8 errores matemáticos más costosos (y cómo evitarlos)', 'Casos reales de Falta Envido que cambiaron partidas enteras']
}, {
  number: 3,
  title: 'El Arte del Verso',
  subtitle: 'La mentira científica que convierte un 4 de Copas en un arma de guerra',
  desc: 'El Truco no lo gana el que tiene las mejores cartas. Lo gana el que mejor convence de que las tiene.',
  bullets: ['Los 5 tipos de mentira en el Truco y cuándo usar cada uno', 'Cómo construir tu "personaje de mesa" para que el rival nunca te pueda leer', 'La cara de Truco: los 4 momentos donde el cuerpo te delata (y cómo controlarlo)', 'El Método de Mentira Científica en 4 pasos aplicable desde hoy', 'Los versos argentinos más efectivos para desestabilizar sin generar quilombo', 'Cómo gestionar cuando te agarran mintiendo sin que te afecte', 'El código ético de la mesa: hasta dónde llega el juego y dónde empieza el bardo']
}, {
  number: 4,
  title: 'El Código de la Pareja',
  subtitle: 'La sincronización invisible que aniquila rivales',
  desc: 'En pareja, dos jugadores individuales no son el doble de fuertes. Son la mitad de efectivos si no están coordinados.',
  bullets: ['Las 6 señas esenciales y las 6 señas avanzadas de comunicación silenciosa', 'El lenguaje de las acciones: cómo comunicarte con tu compañero sin señas físicas (legal en torneos)', 'El sistema de liderazgo situacional: quién manda en el Envido y quién en el Truco según cada mano', 'Las 5 estrategias colectivas avanzadas (La Trampa del Pie, El Envido de Sacrificio, La Pared Defensiva)', 'Cómo leer a la pareja rival y explotar sus puntos débiles', 'El protocolo de re-sincronización cuando la pareja se descoordina', 'Cómo manejar el conflicto post-mano sin que afecte el rendimiento']
}, {
  number: 5,
  title: 'Lectura de Rivales',
  subtitle: 'El arte de saber lo que tiene el otro antes de que lo juegue',
  desc: 'El jugador que lee cartas gana manos. El que lee personas, gana partidas enteras.',
  bullets: ['Cómo establecer el "baseline" de cualquier rival en las primeras 3 manos', 'Los 3 canales de información del rival: verbal, paraverbal y no verbal', 'Los 7 arquetipos del truquero argentino (El Impulsivo, El Calculador, El Bluffero, El Miedoso y más)', 'El sistema de perfilado rápido: identificá el arquetipo en 3 manos y aplicá la estrategia', 'Los 8 "tells" más confiables del Truco: cuándo el rival miente aunque no lo sepa', 'Cómo usar el marcador como herramienta de lectura de intenciones', 'Los 5 pilares de la anti-lectura: cómo hacer tu juego completamente ilegible']
}, {
  number: 6,
  title: 'Maestría en Torneos',
  subtitle: 'El sistema completo para dominar cualquier mesa en cualquier contexto',
  desc: 'Todo lo aprendido converge en el nivel donde el Truco deja de ser un pasatiempo y se convierte en una disciplina.',
  bullets: ['La diferencia real entre el jugador de asado y el jugador de torneo', 'El reglamento oficial completo incluyendo la Flor y todas las variantes', 'La preparación pre-torneo de 7 días para maximizar el rendimiento', 'Las 4 fases de una partida de torneo y la estrategia específica de cada una', 'Los 5 saboteadores mentales de la alta presión y cómo neutralizarlos', 'El manejo del tiempo como arma estratégica activa', 'Los 10 Mandamientos del Truquero de Alto Rendimiento', 'Simulación completa de 3 rondas de torneo con decisiones reales explicadas']
}];
export function TomosSection() {
  return <section className="py-24 bg-truco-dark relative" data-id="element-252">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-253">
        <div className="text-center mb-16" data-id="element-254">
          <h2 className="text-4xl font-heading font-bold text-truco-cream mb-4" data-id="element-255">
            El Sistema Paso a Paso
          </h2>
          <p className="text-xl text-truco-creamMuted" data-id="element-256">
            6 tomos diseñados para llevarte de cero a experto.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2" data-id="element-257">
          {TOMOS.map((tomo, index) => <motion.div key={tomo.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="bg-truco-surface border border-truco-gold/20 rounded-xl p-6 md:p-8 hover:border-truco-gold/50 transition-colors group" data-id="element-258">
              <div className="flex items-center gap-4 mb-4" data-id="element-259">
                <div className="w-12 h-12 bg-truco-dark border border-truco-gold rounded-lg flex items-center justify-center shrink-0 group-hover:bg-truco-gold transition-colors" data-id="element-260">
                  <BookOpenIcon className="w-6 h-6 text-truco-gold group-hover:text-truco-dark transition-colors" data-id="element-261" />
                </div>
                <div data-id="element-262">
                  <h3 className="text-xl font-heading font-bold text-truco-cream" data-id="element-263">
                    📘 TOMO {tomo.number}
                  </h3>
                  <p className="text-truco-gold font-bold" data-id="element-264">{tomo.title}</p>
                </div>
              </div>

              <h4 className="text-lg font-medium text-truco-cream mb-2" data-id="element-265">
                {tomo.subtitle}
              </h4>
              <p className="text-sm text-truco-creamMuted mb-6 italic" data-id="element-266">
                {tomo.desc}
              </p>

              <ul className="space-y-3" data-id="element-267">
                {tomo.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-268">
                    <CheckIcon className="w-5 h-5 text-truco-gold shrink-0 mt-0.5" data-id="element-269" />
                    <span className="text-sm text-truco-creamMuted" data-id="element-270">
                      {bullet}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}